<template>
    <el-card>
        <div slot="header" class="move">
            <h3>Activity</h3>
        </div>
        <div class="dashboard-funnel-container pb-4" ref="funnelContainer">
            <div class="row pt-4" v-if="width && hasValue">
                <vue-funnel-graph
                    ref="funnelGraph"
                    :width="width"
                    :height="height"
                    :labels="labels"
                    :values="values"
                    :colors="colors"
                    :sub-labels="subLabels"
                    :direction="direction"
                    :gradient-direction="gradientDirection"
                    :animated="true"
                    :display-percentage="true"
                ></vue-funnel-graph>
            </div>
        </div>
    </el-card>
</template>

<script>
import {VueFunnelGraph} from 'vue-funnel-graph-js';

export default {
    components: {
        VueFunnelGraph
    },
    props: [
        'appearance',
        'tenantId',
        'dashboardId'
    ],
    data() {
        return {
            activityData: [],
            labels: ['New', 'Apps', 'Approvals', 'Options', 'Settled'],
            subLabels: [],
            values: [],
            colors: [
                ['#7b4397', '#dc2430'],
                ['#ff5f6d', '#ffc371'],
                ['#185a9d', '#43cea2'],
                ['#FFB178', '#FF3C8E'],
                ['#A0BBFF', '#EC77FF'],
                ['#A0F9FF', '#7795FF'],
                ['#F4E2D8', '#BA5370'],
                ['#43cea2', '#185a9d'],
            ],
            direction: 'horizontal',
            gradientDirection: 'horizontal',
            height: 300,
            width: 0
        }
    },
    mounted() {
        $('.dashboard-funnel-container').on('mouseover', '.svg-funnel-js .svg-funnel-js__label', function (e) {
            $(this).addClass('column-stat-hover');
        }).on('mouseout', '.svg-funnel-js .svg-funnel-js__label', function (e) {
            $(this).removeClass('column-stat-hover');
        })

        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.activityData = event.pipeline.pipeline

            this.values = Object.values(this.activityData.values)
            this.subLabels = Object.values(this.activityData.subLabels)

            console.log('activity-values', this.values, this.subLabels)

            this.graphColorChange()
            this.graphBGColorChange()
            this.resizeEventHandler()
        })
    },
    created() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.activityData = event.pipeline.pipeline

            this.values = Object.values(this.activityData.values);
            this.subLabels = Object.values(this.activityData.subLabels);

            this.graphColorChange()
            this.graphBGColorChange()
            window.addEventListener("resize", this.resizeEventHandler)
        })
    },
    computed: {
        hasValue() {
            return !!this.values.find(col => col.length > 0);
        },
    },
    destroyed() {
        window.removeEventListener("resize", this.resizeEventHandler)
        Echo.leave(`dashboard.${this.tenantId}.${this.dashboard}`)
    },
    methods: {
        graphBGColorChange() {
            return this.appearance == "white" ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255,255,255, 0.9)'
        },
        graphColorChange() {
            return this.appearance == 'black' ? "#fff" : "#000"
        },
        resizeEventHandler() {
            if (this.hasValue && this.$refs.funnelContainer && this.$refs.funnelContainer.clientWidth) {
                this.width = this.$refs.funnelContainer && this.$refs.funnelContainer.clientWidth - 2
                this.funnelRefresh(this.$refs.funnelGraph)
            }
        },
        funnelRefresh: _.debounce((funnel) => {
            if (funnel && typeof funnel['$mount'] !== 'undefined') {
                funnel.$mount();
            }
        }, 300),
    }
}
</script>

<style lang="scss">
.move {
    cursor: move;
}

.svg-funnel-js .column-stat-hover {
    cursor: help;
    font-weight: 600;
}

.svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__segment-percentages {
    width: auto;
    white-space: nowrap;
    z-index: 99999999999999999;
}

.svg-funnel-js {
    font-family: "Poppins", serif;

    .svg-funnel-js__labels {

        height: calc(100% - 45px);

        .svg-funnel-js__label {

            .label__value {
                color: #284da5;
            }

            .label__title {
                color: #555555;
            }

            .label__percentage {
                color: #2493ee;
            }

            .label__segment-percentages {
                padding: 0px 14px;
                width: auto;
                white-space: nowrap;
                z-index: 1019;
            }

        }

    }

    &:not(.svg-funnel-js--vertical) {

        .svg-funnel-js__label {

            &:not(:first-child) {
                border-left: 1px solid #5555557e;
            }
        }
    }

    &.svg-funnel-js--vertical {

        .svg-funnel-js__label {

            &:not(:first-child) {
                border-top: 1px solid #5555557e;
            }
        }
    }

    .svg-funnel-js__subLabels {

        background: transparent;

        .svg-funnel-js__subLabel {
            color: #555555;
        }

        .svg-funnel-js__subLabel--title {
            white-space: nowrap;
        }
    }
}
</style>
